
<div class="login-container container-fluid">
  <app-maintenance-banner ifSettingTrue="Login_MaintenanceBanner_Enabled"></app-maintenance-banner>
  <div class="login-user-container">
    <div class="main-container">
      <div class="login-panel">
        <div class="subheader-semi-m super-heading-text">
          <adp-label labelKey="Global_Portal_Site_Name"></adp-label>
        </div>
        <h1 class="header-semi-xl heading-text">
          <adp-label labelKey="Login_Header_Text"></adp-label>
        </h1>
        <div class="login-flow">
          <h2 class="paragraph-body-l-reg subheading-text mt-4 mb-4">
            <adp-label labelKey="Login_Main_Text"></adp-label>
          </h2>
          <div id="sign-in-widget" class="sign-in-widget-container">
          </div>
        </div>
        <hr class="separator mt-4">
        <div class="mt-2 text-center paragraph-body-l-reg">
          <a href="javascript:void(0)" (click)="navigateToSignUp()" class="signup-link" [gtmClick]="getViewLabel('Login_SignUp_Link_Text')" [gtmLinkURL]="this.createAccountRoute()">
            <adp-label labelKey="Login_SignUp_Link_Text"></adp-label>
          </a>
        </div>
      </div>
      <div class="img-panel" [class.hide-on-mobile]="hideMainImageOnMobile()">
        <adp-image imageKey="Global_Login_Main_Image"></adp-image>
      </div>
    </div>
  </div>
</div>
